var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loading ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container mb-5 pb-5 vaillantCont" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-9 col-md-5 pt-4" }, [
            _c(
              "form",
              {
                staticClass: "forgot-password mt-3  pt-4 pb-4",
                attrs: { id: "forgot-form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.forgot($event)
                  }
                }
              },
              [
                !_vm.state
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-12 mb-3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "group custInput ",
                                class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.username,
                                      expression: "username"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        email: true,
                                        temporaryEmail: true,
                                        plusIssueEmail: true,
                                        max: 56
                                      },
                                      expression:
                                        "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("username"),
                                    valid: !!_vm.username
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "username",
                                    name: "username",
                                    "data-vv-as": "Email"
                                  },
                                  domProps: { value: _vm.username },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.username = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "username" }
                                  },
                                  [_vm._v("Email")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("username")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.errors.first("username")
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.error
                                  ? _c(
                                      "div",
                                      { staticClass: "mb-3 text-left" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "errorMes ml-1" },
                                          [_vm._v(_vm._s(_vm.error))]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-12 mb-3 mt-3 text-center " },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary btm-lg",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { type: "submit" }
                                },
                                [_vm._v("Invia")]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  : _c("div", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-row justify-content-center" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-md-12 mb-3 text-center" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "btn btn-primary btn-lg mt-4",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { to: "/" }
                                },
                                [_vm._v("Continua")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12 col-md-12" }, [
      _c("h3", { staticClass: "Bold center pt-5 widthFull" }, [
        _c("strong", [_vm._v("Recupero Password")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c(
        "label",
        { staticClass: "widthFull text-center", attrs: { for: "email" } },
        [
          _c("h5", { staticClass: "Regular black widthFull text-center" }, [
            _vm._v(
              "Inserisci l'indirizzo email che hai inserito in fase di registrazione, e clicca Invia"
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "Regular black widthFull text-center mt-3" }, [
            _vm._v(
              "Ti sarà inviata una email con il link per recuperare la tua password."
            )
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 mb-3 mt-3" }, [
        _c(
          "h5",
          {
            staticClass: "center pl-4 pr-4",
            attrs: { for: "email", role: "alert" }
          },
          [
            _c("p", { staticClass: "black" }, [
              _vm._v(
                "Ti è stata inviata una mail con il link per reimpostare la tua password di accesso,controlla nella tua posta in arrivo."
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "black" }, [
              _vm._v(
                "Se non dovessi trovarla controlla anche nella casella spam."
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ea681d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea681d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forgotpassword/index.vue
// module id = null
// module chunks = 